import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[appStepContent]',
  standalone: false,
})
export class StepContentDirective {
  constructor(public content: TemplateRef<any>) {}
}
